
document.addEventListener('submit', function(event) {
  const form = event.target.closest('.rs-finder-form');
  if (!form) return;
  const category = form.querySelector('[data-rs-category]');
  form.action = category.value;
  const min = form.querySelector('input[name$=".gte"]');
  const max = form.querySelector('input[name$=".lte"]');
  if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
    event.preventDefault();
    max.setCustomValidity(max.getAttribute('data-range-error'));
    max.reportValidity();
  }
});
document.addEventListener('input', function(event) {
  if (event.target.closest('.rs-finder-form') && event.target.setCustomValidity) event.target.setCustomValidity('');
});
